import { render, staticRenderFns } from "./yqg-icon-collapse.vue?vue&type=template&id=0588a4f4&scoped=true&"
import script from "./yqg-icon-collapse.vue?vue&type=script&lang=js&"
export * from "./yqg-icon-collapse.vue?vue&type=script&lang=js&"
import style0 from "./yqg-icon-collapse.vue?vue&type=style&index=0&id=0588a4f4&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588a4f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/fintopia-web7chz7/fintopia-web-ci/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0588a4f4')) {
      api.createRecord('0588a4f4', component.options)
    } else {
      api.reload('0588a4f4', component.options)
    }
    module.hot.accept("./yqg-icon-collapse.vue?vue&type=template&id=0588a4f4&scoped=true&", function () {
      api.rerender('0588a4f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "common/vue/component/yqg-icon-collapse/yqg-icon-collapse.vue"
export default component.exports